<template>
  <div class="header-top">
    <div class="header-top__container">

      <div class="header-top__country">
        <div class="header-top__country-wrap" v-click-outside="closeCountry">
          <button
            type="button"
            class="header-top__country-toggle"
            :aria-pressed="country_open ? 'true' : 'false'"
            aria-controls="header-top-country-menu"
            @click="toggleCountry"
          >
            <span class="header-top__country-toggle-label">Country | </span>
            <span class="header-top__country-toggle-value">CA</span>
          </button>
          <ul
            id="header-top-country-menu"
            class="header-top__country-list"
            :aria-hidden="country_open ? 'false' : 'true'"
          >
            <li class="header-top__country-item header-top__country-item--active">
              <a class="header-top__country-link" href="https://justcuts.ca">CA</a>
            </li>
            <li class="header-top__country-item" v-for="site in site_links" :key="site.path">
              <a class="header-top__country-link" :href="site.path" :target="site.target || '_self'" rel="noopener">{{ site.title }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="header-top__menu">
        <ul class="header-top__menu-list">
          <li class="header-top__menu-item">
            <a class="header-top__menu-link" href="/contact">Contact</a>
          </li>
          <li class="header-top__menu-item header-top__menu-item--has-dropdown" v-click-outside="closeFranchising">
            <a class="header-top__menu-link" href="/franchising">Franchising</a>
            <button
              type="button"
              class="header-top__menu-toggle"
              :aria-pressed="franchising_open ? 'true' : 'false'"
              aria-controls="header-top-franchising-menu"
              aria-label="Toggle franchising menu"
              @click="toggleFranchising"
            ></button>
            <ul
              id="header-top-franchising-menu"
              class="header-top__submenu"
              :aria-hidden="franchising_open ? 'false' : 'true'"
            >
              <li class="header-top__submenu-item" v-for="item in franchising_links" :key="item.path">
                <a class="header-top__submenu-link" :href="item.path" :target="item.target || '_self'" rel="noopener">{{ item.title }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>


<script>
import NavigationList from "../../models/NavigationList";

export default {
  data(){
    return {
      country_open: false,
      franchising_open: false,
      franchising_links: [],
      site_links: []
    }
  },
  async mounted(){
    const [franchising, sites] = await Promise.all([
      NavigationList.getByName("franchising"),
      NavigationList.getByName("sites")
    ]);
    this.franchising_links = franchising ? franchising.list : [];
    this.site_links = sites ? sites.list : [];
  },
  directives: {
    'click-outside': {
      mounted(el, binding){
        el.__clickOutsideHandler__ = (event) => {
          if (!(el === event.target || el.contains(event.target))){
            binding.value(event);
          }
        };
        document.addEventListener('click', el.__clickOutsideHandler__);
      },
      unmounted(el){
        document.removeEventListener('click', el.__clickOutsideHandler__);
      }
    }
  },
  methods: {
    toggleCountry(){
      this.country_open = !this.country_open;
      if (this.country_open) this.franchising_open = false;
    },
    toggleFranchising(){
      this.franchising_open = !this.franchising_open;
      if (this.franchising_open) this.country_open = false;
    },
    closeCountry(){
      this.country_open = false;
    },
    closeFranchising(){
      this.franchising_open = false;
    }
  }
}
</script>
